import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import accountContext from "../../account/accountContext";
import { buildAccountSignInWithReturn } from "../../account/routes";
import useDefaultRedirect from "../../account/hooks/useDefaultRedirect";

export interface AuthorizedRouteProps {
  role?: string | string[];
  redirectTo?: string;
}

export const UnauthorizedRoute = () => {
  const { defaultRoute } = useDefaultRedirect();

  if (accountContext.user) {
    return (<Navigate to={defaultRoute()} replace />);
  }

  return (<Outlet />);
}

export const AuthorizedRoute = ({ role, redirectTo }: AuthorizedRouteProps) => {
  const location = useLocation();
  const fromUrl = `${location.pathname}${location.search}${location.hash}`;
  const { defaultRoute } = useDefaultRedirect();

  const hasRole = !role || (
    Array.isArray(role)
      ? role.includes(accountContext.user?.role || '')
      : accountContext.user?.role === role
  );

  if (accountContext.user && hasRole) {
    return <Outlet />;
  }

  if (accountContext.user && !hasRole) {
    return <Navigate to={defaultRoute()} replace />;
  }

  const signInWithReturn = redirectTo || buildAccountSignInWithReturn(fromUrl);
  return <Navigate to={signInWithReturn} replace />;
}